import client, { Config } from 'amplitude-js';
import { User, TrackEvent } from '../types';
import { IS_PRODUCTION } from '../constants';

const COMMON_CONFIG: Config = {
  batchEvents: false,
  logLevel: 'DISABLE',
  domain: '.adjust.com',
};

const instance = client.getInstance();

export const getConfig = () => {
  if (IS_PRODUCTION) {
    return {
      key: '223be679c0cb3083b6d33145fe356802',
      config: {
        ...COMMON_CONFIG,
        batchEvents: true,
      },
    };
  }

  return {
    key: '1e984809f803a91b006630d4cfe9ba49',
    config: COMMON_CONFIG,
  };
};

export const initTracking = () => {
  const { key, config } = getConfig();

  instance.setOptOut(true);
  instance.init(key, undefined, config);
};

const shouldTrackForUser = (user: User) => {
  if (!IS_PRODUCTION) {
    return false;
  }

  return user.main_account_id !== 65 && user.main_account_id !== 8295;
};

export const startTracking = (user: User) => {
  if (!shouldTrackForUser(user)) {
    instance.setOptOut(true);
    instance.setUserId(null);
    instance.clearUserProperties();
    return;
  }

  instance.setOptOut(false);
  instance.setUserProperties({
    role: user.super_admin ? 'super_admin' : user.role,
    language: user.language,
  });
};

export const trackEvent: TrackEvent = (name, data) => {
  instance.logEvent(`deeplink_generator_${name}`, data);
};
